import React from 'react';

import * as Style from './CategoryNavProductsModalDesktop.style';
import { ProductLinks } from '..';
import { Link } from 'gatsby';
import { CurologySiteAndShopNavCardFlag } from 'consts/featureFlagsAndMetrics';
import { useFlag } from 'utils/featureFlagsAndMetrics';

export const CategoryNavProductsModalDesktop = () => {
  const curologySiteAndShopNavCard = useFlag<
    CurologySiteAndShopNavCardFlag | undefined
  >('curology-site-and-shop-nav-card');

  return (
    <React.Fragment>
      <Style.CategoryNavLinksContainer>
        <ProductLinks />
      </Style.CategoryNavLinksContainer>
      <Style.CategoryNavImageContainer>
        {curologySiteAndShopNavCard && (
          <Link to={curologySiteAndShopNavCard.linkUrl}>
            <img
              src={curologySiteAndShopNavCard.desktopImageUrl}
              alt="Link to shop.curology.com"
              width={curologySiteAndShopNavCard.desktopImageWidth}
            />
          </Link>
        )}
      </Style.CategoryNavImageContainer>
    </React.Fragment>
  );
};
